export const GoogleTagManagerName = "contents-calc-max-content";
export const GoogleTagManagerEvent = "pop_up";
export const GoogleTagManagerSubmittedAction = "submit";
export const GoogleTagManagerPopUpOpenAction = "open";
export const GoogleTagManagerPopUpCloseAction = "close";
